<div class="agpr-curationAgentSourceRow agpr-contextMenu-parent">
    <div class="agpr-contextMenu top right">
        <agpr-button
            [id]="id + '.viewSource'"
            [style]="buttonTypes.contextMenu"
            icon="fa-regular fa-duotone fa-eye"
            tooltip="Monitoring.sourcePickerField.header.viewSource"
            tooltipPosition="left"
            [ariaLabel]="'Monitoring.sourcePickerField.header.viewSource' | localize"
            [disabled]="!source.isComplete()"
            (click)="viewSource($event)"
        ></agpr-button>
        @if (canRemove) {
            <agpr-button
                [id]="id + '.remove'"
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-duotone fa-trash-can"
                tooltip="AutomationAgents.panel.sources.remove"
                tooltipPosition="left"
                [ariaLabel]="'AutomationAgents.panel.sources.remove' | localize"
                (click)="remove()"
            ></agpr-button>
        }
    </div>

    <div class="agpr-curationAgentSourceRow-header">
        <span class="agpr-curationAgentSourceRow-label">
            @if (heading) {
                {{ heading | localize }}
            } @else {
                {{ 'AutomationAgents.panel.sources.sourceLabel' | localize: { position: position } }}
            }
        </span>
    </div>

    <agpr-monitoring-source-picker-without-facet-field
        [id]="id + '.picker'"
        [field]="field"
        [value]="source.dataSource"
        [showErrors]="false"
        [excludedAiAgentIds]="agentId ? [agentId] : []"
        (changes)="onDataSourceChanged($event)"
    ></agpr-monitoring-source-picker-without-facet-field>

    <!-- Anything the caller wants inside the card, beneath the picker - the ad hoc panel's date range -->
    <ng-content></ng-content>

    <!-- Nothing to estimate until coverage has been picked -->
    @if (showQuota && source.isComplete()) {
        <agpr-message
            class="agpr-curationAgentSourceRow-quota"
            [id]="id + '.quota'"
            [severity]="messageSeverity.info"
            [loading]="countingQuota"
            [bottomMargin]="false"
        >
            {{
                'AutomationAgents.panel.sources.quotaEstimate'
                    | localize: { quota: source.estimatedMonthlyQuota ?? ('AutomationAgents.notAvailable' | localize) }
            }}
        </agpr-message>
    }
</div>
